<template>
    <v-card outlined @click="HandleClick(profile)" >
        <v-card-text>
            <v-row justify="center" align="center" style="height: 120px;">
                <v-col align="center">
                    <v-avatar size="100">
                        <v-img :src="profile.profilepic"/>
                    </v-avatar>
                    <div class="warning--text font-weight-light">{{profile.firstname}} {{profile.lastname}}</div>
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'

  export default {
    props: ['profile'],
    name: "PlayerCardItem",
    components: {},
    data() {
      return {}
    },
    computed: {
      ...mapState([])
    },
    methods: {
      ...mapActions(['get', 'post']),
      HandleClick(p){
        if(this.islink){
          this.$router.push('/myathletes/profile/'+p.partkey)
        }else{
          this.$emit('selected',p)
        }
      }
    }
  }

</script>

<style scoped>

</style>